import { useCallback, useEffect } from 'react';
export var GetEvents;
(function (GetEvents) {
    GetEvents["ABORT"] = "applepaySDK:abort";
})(GetEvents || (GetEvents = {}));
export var useGetEvents = function (onEventReceieved) {
    var onEventReceievedFun = useCallback(function (msg) {
        var event = msg.data.event;
        onEventReceieved(event);
    }, [onEventReceieved]);
    useEffect(function () {
        window.addEventListener('message', onEventReceievedFun);
        return function () { return window.removeEventListener('message', onEventReceievedFun); };
    }, [onEventReceievedFun]);
};
